import { Directive, ElementRef, HostListener } from '@angular/core';
import { MainService } from '../../services/main-service.service'
@Directive({
    selector: '[appDecimaNumber]',
    standalone: true
})
export class DecimaNumberDirective {
    private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete', 'Enter'];
    private currencyCode: string = 'usd';

    constructor(private el: ElementRef, private mainService: MainService) {
        this.currencyCode = this.mainService.currency_data.currency_code;
        let decimal_number = this.el.nativeElement.getAttribute('appDecimaNumber')
        if (decimal_number != '') {
            decimal_number = parseInt(decimal_number);
            this.regex = new RegExp('^\\d*\\.?\\d{0,' + decimal_number + '}$');
        }
        if (this.mainService.noDecimalCurrencies.includes(this.currencyCode)) {
            this.regex = new RegExp(/^\d+$/g);
        }
    }
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        let current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        const next: string = [current.slice(0, position), event.key == '.' ? '.' : event.key, current.slice(position)].join('');
        if (this.mainService.noDecimalCurrencies.includes(this.currencyCode) && (event.key === '.' || event.key === 'Decimal')) {
            event.preventDefault();
        }
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}